// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SignupGridSkeleton-serviceProviderSkeletonContainer-ArGJW {
  padding: 35px 108px;
  background-color: var(--skeleton-primary-bg);
  border-radius: 0 24px 0 24px;
  margin-top: 42px;
}

.SignupGridSkeleton-serviceProviderSkeletonWrapper-YbUQe {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  display: grid;
  grid-template-columns: 1fr 350px;
  gap: 20px;
}

.SignupGridSkeleton-serviceProviderSkeletonImgContainer-Xn6u5 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}

.SignupGridSkeleton-serviceProviderSkeletonImg-VAYIO {
  max-width: 300px;
  height: 470px;
  background-color: var(--skeleton-secondary-bg);
  border-radius: var(--radius-4);
}

.SignupGridSkeleton-serviceProviderSkeletonHeading-uASnP {
  max-width: 539px;
  height: 46px;
  background-color: var(--skeleton-secondary-bg);
  border-radius: var(--radius-5);
}

.SignupGridSkeleton-serviceProviderSkeletonContent-gXMPu {
  max-width: 411px;
  height: 28px;
  background-color: var(--skeleton-secondary-bg);
  border-radius: var(--radius-5);
  margin-top: 18px;
}

.SignupGridSkeleton-serviceProviderSkeletonBtnGrp-Zr09R {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 12px;
  margin-top: 30px;
}

.SignupGridSkeleton-serviceProviderSkeletonBtn-OISp9 {
  max-width: 168px;
  height: 52px;
  background-color: var(--skeleton-secondary-bg);
  border-radius: var(--radius-5);
}

@media (min-width:1200px) {
  .SignupGridSkeleton-serviceProviderSkeletonWrapper-YbUQe {
    grid-template-columns: 1fr 400px;
  }
}

@media (max-width:991px) {
  .SignupGridSkeleton-serviceProviderSkeletonContainer-ArGJW {
    padding: 35px 30px;
  }
}

@media (max-width:767px) {
  .SignupGridSkeleton-serviceProviderSkeletonContainer-ArGJW {
    padding: 35px 15px;
  }

  .SignupGridSkeleton-serviceProviderSkeletonWrapper-YbUQe {
    grid-template-columns: 100%;
  }

  .SignupGridSkeleton-serviceProviderSkeletonImg-VAYIO {
    height: 370px;
  }

  .SignupGridSkeleton-serviceProviderSkeletonHeading-uASnP {
    height: 32px;
  }

  .SignupGridSkeleton-serviceProviderSkeletonContent-gXMPu {
    height: 24px;
    margin-top: 16px;
  }

  .SignupGridSkeleton-serviceProviderSkeletonBtnGrp-Zr09R {
    margin-top: 24px;
  }

  .SignupGridSkeleton-serviceProviderSkeletonImgContainer-Xn6u5 {
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/Home/SignupGridSkeleton/SignupGridSkeleton.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,uBAA2B;MAA3B,oBAA2B;UAA3B,2BAA2B;EAC3B,mBAAe;MAAf,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;EACzB;AACF","sourcesContent":[".serviceProviderSkeletonContainer {\n  padding: 35px 108px;\n  background-color: var(--skeleton-primary-bg);\n  border-radius: 0 24px 0 24px;\n  margin-top: 42px;\n}\n\n.serviceProviderSkeletonWrapper {\n  align-items: center;\n  display: grid;\n  grid-template-columns: 1fr 350px;\n  gap: 20px;\n}\n\n.serviceProviderSkeletonImgContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.serviceProviderSkeletonImg {\n  max-width: 300px;\n  height: 470px;\n  background-color: var(--skeleton-secondary-bg);\n  border-radius: var(--radius-4);\n}\n\n.serviceProviderSkeletonHeading {\n  max-width: 539px;\n  height: 46px;\n  background-color: var(--skeleton-secondary-bg);\n  border-radius: var(--radius-5);\n}\n\n.serviceProviderSkeletonContent {\n  max-width: 411px;\n  height: 28px;\n  background-color: var(--skeleton-secondary-bg);\n  border-radius: var(--radius-5);\n  margin-top: 18px;\n}\n\n.serviceProviderSkeletonBtnGrp {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 30px;\n}\n\n.serviceProviderSkeletonBtn {\n  max-width: 168px;\n  height: 52px;\n  background-color: var(--skeleton-secondary-bg);\n  border-radius: var(--radius-5);\n}\n\n@media (min-width:1200px) {\n  .serviceProviderSkeletonWrapper {\n    grid-template-columns: 1fr 400px;\n  }\n}\n\n@media (max-width:991px) {\n  .serviceProviderSkeletonContainer {\n    padding: 35px 30px;\n  }\n}\n\n@media (max-width:767px) {\n  .serviceProviderSkeletonContainer {\n    padding: 35px 15px;\n  }\n\n  .serviceProviderSkeletonWrapper {\n    grid-template-columns: 100%;\n  }\n\n  .serviceProviderSkeletonImg {\n    height: 370px;\n  }\n\n  .serviceProviderSkeletonHeading {\n    height: 32px;\n  }\n\n  .serviceProviderSkeletonContent {\n    height: 24px;\n    margin-top: 16px;\n  }\n\n  .serviceProviderSkeletonBtnGrp {\n    margin-top: 24px;\n  }\n\n  .serviceProviderSkeletonImgContainer {\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"serviceProviderSkeletonContainer": `SignupGridSkeleton-serviceProviderSkeletonContainer-ArGJW`,
	"serviceProviderSkeletonWrapper": `SignupGridSkeleton-serviceProviderSkeletonWrapper-YbUQe`,
	"serviceProviderSkeletonImgContainer": `SignupGridSkeleton-serviceProviderSkeletonImgContainer-Xn6u5`,
	"serviceProviderSkeletonImg": `SignupGridSkeleton-serviceProviderSkeletonImg-VAYIO`,
	"serviceProviderSkeletonHeading": `SignupGridSkeleton-serviceProviderSkeletonHeading-uASnP`,
	"serviceProviderSkeletonContent": `SignupGridSkeleton-serviceProviderSkeletonContent-gXMPu`,
	"serviceProviderSkeletonBtnGrp": `SignupGridSkeleton-serviceProviderSkeletonBtnGrp-Zr09R`,
	"serviceProviderSkeletonBtn": `SignupGridSkeleton-serviceProviderSkeletonBtn-OISp9`
};
module.exports = ___CSS_LOADER_EXPORT___;
